// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__n3Dxx","column":"style_column__1MThp","row":"style_row__3oAS8"};